import Vue from 'vue'

export default {
    UPDATE_GREETING (state, value) {
        Vue.set(state, 'greetings', value);
    },
  SET_GREETINGS (state, value) {
        this.commit('UPDATE_GREETINGS', value);
    },
    SET_SELECTED_GREETING (state,  value ) {
      Vue.set(state, 'selectedGreeting', value);
    },
}



// WEBPACK FOOTER //
// ./src/store/modules/greetings/mutations.js